import Crud from '../views/Classification/Crud'
import Entity from '../views/Classification/Add'

let routes = {
    path: '/classifications',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/classifications/add',
            name: 'NewClassification',
            component: Entity,
            meta: {
                pageTitle: 'classification.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'classification.form.titleNew',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/classifications/edit/:id?',
            name: 'EditClassification',
            component: Entity,
            meta: {
                pageTitle: 'classification.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'classification.form.titleEdit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/classifications',
            name: 'list-classifications',
            component: Crud,
            meta: {
                pageTitle: 'classification.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'classification.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
